import { useState } from "react";
import { createTicketMessage, setAdminAnswered } from "../../api/tickets";
import Navigation from "../Navigation";
import { XMarkIcon } from "@heroicons/react/24/outline";
import Notification from "../Notification";

const TicketMessage = ({
  selectedTicket,
  ticketMessages,
  messagesLoading,
  setLoading,
  setTicketMessages,
  closeModal,
  setRefreshTokens,
}) => {
  const [messageContent, setMessageContent] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [status, setStatus] = useState(null);

  const formatMessageDate = (date) =>
    new Date(date).toLocaleString("fa-IR", {
      hour: "2-digit",
      minute: "2-digit",
      month: "numeric",
      day: "numeric",
    });

  const handleSendMessage = async () => {
    setLoading(true);
    if (!messageContent.trim()) return;

    const res = await createTicketMessage({
      ticketId: selectedTicket._id,
      content: messageContent.trim(),
    });

    if (res.status === 201) {
      const res2 = await setAdminAnswered(selectedTicket._id);
      if (res2.status !== 200) {
        alert("به برنامه نویس اطلاع دهید  تغییر وضعیت انجام نشد");
      }
      setRefreshTokens((prev) => !prev);
      setStatus(201);
      setShowNotification(true);
      setTicketMessages((prevMessages) => [
        ...prevMessages,
        {
          _id: res.data.message._id,
          sender: "admin",
          messageContent: messageContent.trim(),
          created_at: res.data.message.created_at,
        },
      ]);
      setMessageContent("");
    } else {
      setStatus(res.status);
    }

    setLoading(false);
  };

  const getNotificationProps = () => {
    switch (status) {
      case 201:
        return {
          message: "ارسال پیام موفقیت آمیز بود",
          type: "success",
          duration: 3000,
        };

      case 500:
        return {
          message: "مشکل سرور، لطفا دوباره تلاش کنید",
          type: "error",
          duration: 3000,
        };

      case 401:
        return {
          message: "مشکل احراز هویت، لطفا دوباره وارد شوید",
          type: "info",
          duration: 3000,
        };

      case 404:
        return {
          message: "مشکل احراز هویت، لطفا دوباره وارد شوید",
          type: "info",
          duration: 3000,
        };

      default:
        return null;
    }
  };

  const notificationProps = getNotificationProps();

  return (
    <div className="w-full">
      {showNotification ? (
        <Notification
          {...notificationProps}
          setShowNotification={setShowNotification}
          showNotification={showNotification}
        />
      ) : null}
      <div className="flex flex-row w-full lg:flex-row gap-6">
        <div className=" w-full  flex items-center justify-center">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl flex flex-col">
            {/* هدر مودال */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-t-2xl">
              <div>
                <h2 className="text-xl text-gray-800 font-bold">
                  {selectedTicket.ticketTitle || "تیکت بدون عنوان"}
                </h2>
                <div className="flex items-center gap-4 mt-2 text-gray-800 text-sm">
                  <span>شماره تیکت: #{selectedTicket._id}</span>
                  <span>
                    تاریخ ایجاد: {formatMessageDate(selectedTicket.created_at)}
                  </span>
                </div>
              </div>
              <button onClick={closeModal} className="p-2">
                <XMarkIcon className="h-5 w-5 ml-2" />
              </button>
            </div>

            {/* اطلاعات کاربر */}
            <div className="p-4 bg-gray-50 border-b border-gray-200">
              <div className="flex flex-row justify-between gap-4 text-sm">
                <div className="flex flex-col gap-2">
                  <span className="text-gray-500">نام کاربر:</span>
                  <span className="font-semibold text-gray-800 mr-2">
                    {selectedTicket.authorId?.name || "نامشخص"}
                  </span>
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-gray-500">شماره تماس:</span>
                  <span className="font-semibold text-gray-800 mr-2 dir-ltr">
                    {selectedTicket.authorId?.phone || "نامشخص"}
                  </span>
                </div>
                <div className="flex flex-col gap-2">
                  <span className="text-gray-500">وضعیت:</span>
                  <span
                    className={`px-2 py-1 text-xs rounded-full font-medium mr-2 ${
                      selectedTicket.status === "open"
                        ? "bg-green-500 text-white"
                        : selectedTicket.status === "adminAnswered"
                        ? "bg-green-100 text-green-700"
                        : selectedTicket.status === "userAnswered"
                        ? "bg-blue-500 text-white"
                        : selectedTicket.status === "close"
                        ? "bg-red-300 text-red-600"
                        : selectedTicket.status === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : null
                    }`}
                  >
                    {selectedTicket.status === "open"
                      ? "تازه باز شده"
                      : selectedTicket.status === "adminAnswered"
                      ? "پاسخ داده شده"
                      : selectedTicket.status === "userAnswered"
                      ? "کاربر پاسخ داده"
                      : selectedTicket.status === "close"
                      ? "بسته شده"
                      : selectedTicket.status === "pending"
                      ? "در حال بررسی"
                      : null}
                  </span>
                </div>
              </div>
            </div>

            {/* لیست پیام‌ها */}
            <div className="flex-1 flex flex-col">
              {messagesLoading ? (
                <div className="flex justify-center items-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500"></div>
                  <span className="mr-3 text-gray-600">
                    در حال بارگذاری پیام‌ها...
                  </span>
                </div>
              ) : ticketMessages.length > 0 ? (
                <div className="flex-1 overflow-y-auto p-6 pr-2 space-y-4">
                  {ticketMessages.map((message) => (
                    <div
                      key={message._id}
                      className={`flex ${
                        message.sender !== "user"
                          ? "justify-end"
                          : "justify-start"
                      }`}
                    >
                      <div
                        className={`max-w-[80%] p-4 rounded-2xl ${
                          message.sender !== "user"
                            ? "bg-green-100 border border-green-200"
                            : "bg-blue-100 border border-blue-200"
                        }`}
                      >
                        <div className="flex items-center justify-between mb-2 gap-3">
                          <span
                            className={`font-semibold text-sm ${
                              message.sender === "user"
                                ? "text-blue-700"
                                : "text-green-700"
                            }`}
                          >
                            {message.sender !== "user"
                              ? "👨‍💼 پشتیبانی"
                              : selectedTicket.authorId?.name || "کاربر"}
                          </span>
                          <span className="text-xs text-gray-500 whitespace-nowrap">
                            {formatMessageDate(message.created_at)}
                          </span>
                        </div>
                        <div className="text-gray-800 leading-relaxed whitespace-pre-wrap">
                          {message.messageContent}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="flex-1 flex items-center justify-center text-gray-500">
                  هیچ پیامی در این تیکت ثبت نشده است.
                </div>
              )}
            </div>

            {/* ارسال پیام */}
            <div className="p-4 border-t border-gray-200">
              <div className="flex items-center gap-3">
                <textarea
                  name="message"
                  id="message"
                  rows="3"
                  className="flex-1 p-3 border border-gray-300 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="پیام خود را وارد کنید..."
                  value={messageContent}
                  onChange={(e) => setMessageContent(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      e.preventDefault();
                      handleSendMessage();
                    }
                  }}
                ></textarea>
                <button
                  onClick={handleSendMessage}
                  disabled={!messageContent.trim()}
                  className="w-24 h-12 px-4 text-white rounded-lg bg-blue-500 hover:bg-blue-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors font-medium"
                >
                  ارسال
                </button>
              </div>
            </div>

            {/* فوتر مودال */}
            <div className="p-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
              <div className="flex justify-end gap-3">
                <button
                  onClick={closeModal}
                  className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors font-medium"
                >
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketMessage;
